<template>
  <div id="save_item_list">
    <dd-header
      ref="menuRef"
      :headerType=2
    />
    <div id="container">
      <div id="content">
        <div class="title">
          <h2>商品保存リスト</h2>
        </div>
        <div class="title">
          <h2>カスタマイズ中の商品保存リスト（{{Object.keys(itemList).length}}件 ）</h2>
        </div>
        <div class="caution_field" v-if="isDisProduct===true">
          <div class="caution_inner">
            <div class="caution_title">
              <img class="caution_icon" :src="getImage('common/icon_caution_y.svg')" alt="">
              <p>重要なお知らせ</p>
            </div>
            <ul class="caution_text">
              <li>商品保存リスト内に商品仕様が変更、または取り扱いが終了した商品が含まれています。</li>
              <li>対象商品を商品保存リストから削除し、別の商品をご検討ください。</li>
            </ul>
          </div>
        </div>
        <!-- ページ -->
        <dd-pager
          v-if="itemList && itemList.length > 0"
          :pageNo="pageNo"
          :dataCountPerPage="pageSaveCnt"
          :totalDataCount="itemList.length"
          @callback="paging"
        />
        <!-- <draggable :options="options" @sort="onSort" @start="drug=true" @end="drug=false"> -->
          <div class="input_list" v-for="(item,index) in viewList" :key="'cat-' + index">
            <section class="item_field">
              <div class="caution_field" v-if="item.isDisProduct===true">
                <div class="caution_inner">
                  <ul class="caution_text">
                    <li>この商品は商品仕様が変更、または取り扱いが終了した為、編集できません。</li>
                    <li>商品保存リストから削除してください。</li>
                  </ul>
                </div>
              </div>
              <ul>
                <li class="item_header">
                  <div v-bind:class="{'disabled':item.isDisProduct===true, item_title:true}">
                    <label class="bold" >保存名：{{item.businessName}}</label>
                    <label class="bold">登録日時：{{item.saveDate}}</label>
                  </div>
                  <div class="item_action">
                    <button v-bind:class="{'disabled':item.isDisProduct===true, main_btn:true}" @click="selectProduct(item)">編集</button>
                    <button class="main_btn delete_btn2" @click="deleteProduct(item.productId)">削除</button>
                  </div>
                </li>
                <li v-bind:class="{'disabled':item.isDisProduct===true, list_line2:true}">
                  <div>シリーズ名：</div>
                  <div>{{item.seriesName}}</div>
                </li>
                <li v-bind:class="{'disabled':item.isDisProduct===true, list_line2:true}">
                  <div>商品名：</div>
                  <div>{{item.productName}}</div>
                </li>
                <li v-bind:class="{'disabled':item.isDisProduct===true, list_line2:true}" v-show="item.colorStyle">
                  <div>スタイル名：</div>
                  <div>{{item.colorStyle.colorStyleName}}</div>
                </li>
                <li v-bind:class="{'disabled':item.isDisProduct===true, list_item3:true}">
                  <div class="bold">
                    <label>商品サイズ</label>
                  </div>
                  <div class="item_box">
                    <label class="bold">W：{{item.dcWidth}}mm</label>
                    <label class="bold">H：{{item.dcHeight}}mm</label>
                    <label class="bold">D：{{item.dcDepth}}mm</label>
                  </div>
                </li>
                <template v-if="item.cdcCategoryType==4">
                  <li v-bind:class="{'disabled':item.isDisProduct===true, list_item3:true}" v-if="isEnableFiller(item)">
                    <div class="bold">
                      <label>壁埋め込み</label>
                    </div>
                    <div class="item_box">
                      <label class="bold" v-show="item.dcBSize!=undefined">左壁：{{item.dcBSize}}mm</label>
                      <label class="bold" v-show="item.dcCSize!=undefined">右壁：{{item.dcCSize}}mm</label>
                      <label class="bold" v-show="item.dcDSize!=undefined">奥壁：{{item.dcDSize}}mm</label>
                    </div>
                    <div></div>
                  </li>
                </template>
                <template v-else>
                  <li v-bind:class="{'disabled':item.isDisProduct===true, list_item3:true}" v-if="isEnableFiller(item)">
                    <div class="bold">
                      <label>フィラー</label>
                    </div>
                    <div class="item_box">
                      <label class="bold" v-show="item.dcBSize!=undefined">左フィラー：{{item.dcBSize}}mm</label>
                      <label class="bold" v-show="item.dcCSize!=undefined">右フィラー：{{item.dcCSize}}mm</label>
                      <label class="bold" v-show="item.dcDSize!=undefined">上部フィラー：{{item.dcDSize}}mm</label>
                    </div>
                    <div></div>
                  </li>
                </template>
                <li class="list_line2" v-if="item.dcHeight2 != undefined">
                  <div>取り付け高さ設定：</div>
                  <div>{{item.dcHeight2}}mm</div>
                </li>
                <li v-bind:class="{'disabled':item.isDisProduct===true}">
                  <ul class="color_list">
                    <li v-if="item.dcColorDoorDetail && Object.keys(item.dcColorDoorDetail).length > 0">
                      <dd-color
                        :title="'扉カラー'"
                        :color="item.dcColorDoorDetail"
                      />
                    </li>
                    <li v-if="item.dcColorBoxDetail && Object.keys(item.dcColorBoxDetail).length > 0">
                      <dd-color
                        :title="'キャビネット/棚/脚カラー'"
                        :color="item.dcColorBoxDetail"
                      />
                    </li>
                    <li v-if="item.dcColorCounterDetail && Object.keys(item.dcColorCounterDetail).length > 0">
                      <dd-color
                        :title="'カウンターカラー'"
                        :color="item.dcColorCounterDetail"
                      />
                    </li>
                  </ul>
                </li>
                <li v-bind:class="{'disabled':item.isDisProduct===true, list_line2:true}">
                  <span><label class="bold">可動棚：</label></span>
                  <span><label>{{item.dcShelfCount}}</label></span>
                </li>
                <li v-bind:class="{'disabled':item.isDisProduct===true, list_line2:true}">
                  <span><label class="bold">フィラー数：</label></span>
                  <span><label>{{item.dcFillerCount}}</label></span>
                </li>
                <li v-bind:class="{'disabled':item.isDisProduct===true, list_line2:true}">
                  <span><label class="bold">ご注文数：</label></span>
                  <span><label>{{item.dcProductCount}}</label></span>
                </li>
                <li v-bind:class="{'disabled':item.isDisProduct===true, list_line2:true}">
                  <span><label class="bold">納品先郵便番号：</label></span>
                  <span><label>{{item.dcSaveDeliPostcd}}</label></span>
                </li>
                <template v-if="item.deliAddress && Object.keys(item.deliAddress).length > 0">
                  <li v-bind:class="{'disabled':item.isDisProduct===true, list_line2:true}">
                    <span><label class="bold">納品先住所：</label></span>
                    <span><label>{{item.deliAddress}}</label></span>
                  </li>
                </template>
                <li v-bind:class="{'disabled':item.isDisProduct===true, list_line2:true}">
                  <span><label class="bold">組立設置：</label></span>
                  <span>
                    <label v-if="item.dcWorkFlag===true">あり</label>
                    <label v-else>なし</label>
                  </span>
                </li>
                <template v-if="item.dcWorkFlag==true">
                  <li v-bind:class="{'disabled':item.isDisProduct===true, list_line2:true}">
                    <span><label class="bold">組立設置先郵便番号：</label></span>
                    <span><label>{{item.dcStructPostcd}}</label></span>
                  </li>
                  <li v-bind:class="{'disabled':item.isDisProduct===true, list_line2:true}" v-if="item.dcConstructOpServiceFlag!=undefined">
                    <span><label class="bold">受け取り搬入サービス：</label></span>
                    <span>
                      <label v-if="item.dcConstructOpServiceFlag===true">あり</label>
                      <label v-else>なし</label>
                    </span>
                  </li>
                </template>
                <template v-if="item.dcSaveResrchFlag">
                  <li v-bind:class="{'disabled':item.isDisProduct===true, list_line2:true}">
                    <span><label class="bold">事前現場調査：</label></span>
                    <span>
                      <label v-if="item.dcSaveResrchFlag===true">あり</label>
                      <label v-else>なし</label>
                    </span>
                  </li>
                </template>
                <template v-if="item.dcSaveResrchFlag">
                  <li v-bind:class="{'disabled':item.isDisProduct===true, list_line2:true}">
                    <span><label class="bold">事前現場調査先郵便番号：</label></span>
                    <span><label>{{item.dcSaveResrchPostcd}}</label></span>
                  </li>
                </template>
              </ul>
            </section>
          </div>
        <!-- </draggable> -->
      </div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import {mapActions, mapState} from 'vuex'
// import draggable from 'vuedraggable'

// Module
import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
import Pager from '../../components/common/Pager'
import Header from '../components/common/DcHeader'
import Color from '../components/top/input/color/Color'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  name: 'SaveItemList',
  components: {
    // draggable,
    'dd-header': Header,
    'dd-pager': Pager,
    'dd-color': Color,
    'dd-loading-modal': LoadingModal
  },
  props: {
  },
  data () {
    return {
      options: {
        animation: 200,
        delay: 50
      },
      pageSaveCnt: 20,
      pageNo: 1,
      drug: false
    }
  },
  computed: {
    ...mapState({
      itemList: state => state.itemList
    }),
    viewList: function () {
      if (!this.itemList) return
      let startIdx = (this.pageNo - 1) * this.pageSaveCnt
      let endIdx = ((this.pageNo) * this.pageSaveCnt)
      return this.itemList.filter(function (element, index) {
        return (index >= startIdx && index < endIdx)
      })
    },
    isDisProduct: function () {
      if (!this.itemList || Object.keys(this.itemList).length <= 0) return false
      return this.itemList
        .map(i => i.isDisProduct)
        .includes(true)
    }
  },
  methods: {
    ...mapActions({ getItemList: 'loadSaveProductList' }),
    selectProduct: function (product) {
      App.setLocalStorage(DC_STORAGE_KEY.SAVE_PLAN, product)
      this.$router.push({
        name: 'DcCustomize'
      })
    },
    paging: function (selPage) {
      this.pageNo = selPage
    },
    deleteProduct: function (productId) {
      // 保存リストから削除
      let modalData = {
        messages: ['本当に削除しますか？'],
        modalType: 'confirm',
        textAlign: 'center',
        onOk: () => {
          let payload = {
            params: {
              productId: productId
            }
          }
          axios.get(DC_URL.SAVE + '/delete-product', payload
          ).then(response => {
            this.$store.dispatch('loadSaveProductList')
            let modalData = {
              messages: ['削除しました。'],
              textAlign: 'center'
            }
            App.showModal(modalData)
          }).catch(error => {
            Api.handleError(error, this.errorMessage, this.validateErrorMessages)
            this.$router.push('/mmstyle/error')
          })
        }
      }
      App.showModal(modalData)
    },
    isEnableFiller: function (item) {
      return (item.dcBSize !== undefined || item.dcCSize !== undefined || item.dcDSize !== undefined)
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
    // onMousemove: function (event) {
    //   // let element = document.getElementById('save_item_list')
    //   // console.log('move ev.y:' + event.clientY + ' screenH:' + element.scrollHeight + ' offsetH:' + element.offsetHeight)
    //   // if (element.scrollHeight - (element.offsetHeight + event.clientY) < element.scrollHeight * 0.05) {
    //   //   console.log('scroll end')
    //   // }
    //   // if (this.drug) {
    //   // const scrollAmount = 100
    //   // const par = 0.2
    //   console.log('move ev.y:' + event.clientY + ' screenH:' + window.innerHeight)
    //   // if (event.clientY - 100 < window.innerHeight * par) {
    //   //   window.scrollTo(window.scrollY - scrollAmount, window.scrollX)
    //   // } else
    //   if ((window.innerHeight - event.clientY) < window.innerHeight * 0.2) {
    //     console.log('scroll end')
    //     // スクロールする
    //     // window.scrollTo(window.scrollY + scrollAmount, window.scrollX)
    //     window.scrollTo(0, 0)
    //     // }
    //   }
    // },
    // onSort: function (event) {
    //   console.log('sort')
    // },
    // /** イベントリスナ有効化 */
    // addEventListener: function () {
    //   document.addEventListener('mousemove', this.onMousemove)
    // },
    // /** イベントリスナ無効化 */
    // removeEventListener: function () {
    //   document.removeEventListener('mousemove', this.onMousemove)
    // }
  },
  mounted: function () {
    // this.addEventListener()
    this.$store.dispatch('loadSaveProductList', {reload: true})
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.item {
  display: inline-block;
  margin: 10px;
  padding: 10px;
  border: 1px solid #7f7f7f;
  border-radius: 10px;
  background-color: #ffffff;
}
.item:hover {
  cursor: grab;
}
.item:active {
  cursor: grabbing;
}
#content {
  &.color_title {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/SaveItemList.vue